<template>
  <div>
    <!--
  <el-drawer
    :title="NominaDetailData.Name"
    :visible.sync="historicIsVisible"
    size="100%"
    @close="OnHistoricClose"
  >
  -->
    <!--
  <el-row>
    <el-tooltip class="item" effect="light" content="Filtrar por departamento" placement="top">
      <el-button>top</el-button>
    </el-tooltip>
    <el-tooltip class="item" effect="light" content="Filtrar por empleado" placement="top">
      <el-button>top</el-button>
    </el-tooltip>
    <el-tooltip class="item" effect="light" content="Filtrar por tipo de ingreso" placement="top">
      <el-button>top</el-button>
    </el-tooltip>
    <el-tooltip class="item" effect="light" content="Filtrar por tipo de descuento" placement="top">
      <el-button>top</el-button>
    </el-tooltip>
  </el-row>
  -->
    <el-table
      :data="data2"
      :max-height="500"
      v-loading="fetchingNominaDetailData"
      :stripe="true"
      :border="true"
      :show-summary="true"
      :summary-method="getSummaries"
      :header-row-class-name="getHeaderClass"
    >
      <el-table-column
        label="Opciones"
        :width="100"
        :fixed="true"
        align="center"
        v-if="selectActions !== undefined && selectActions.length > 0"
      >
        <template slot="header" slot-scope="scope">
          <i class="el-icon-setting" :key="scope.$index"></i>
        </template>
        <template slot-scope="scope">
          <el-dropdown
            trigger="click"
            @command="handleCommand"
            v-if="
              conditionalActions({
                index: scope.$index,
                row: scope.row,
                column: scope.column
              })
            "
          >
            <span class="el-dropdown-link">
              <i class="mdi mdi-menu"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(action, index) in selectActions">
                <el-dropdown-item
                  v-if="
                    action.condition !== undefined &&
                    typeof action.condition === 'function'
                      ? action.condition(scope.row)
                      : true
                  "
                  :key="index"
                  :command="{
                    index: scope.$index,
                    row: scope.row,
                    column: scope.column,
                    command: action.command
                  }"
                  :icon="action.icon"
                  >{{ action.label }}</el-dropdown-item
                >
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <!-- <el-table-column label="Informacion de Empleados"> -->
      <el-table-column
        prop="Empleado.ID"
        label="Codigo"
        min-width="100"
        align="center"
        :fixed="true"
        :sortable="true"
      ></el-table-column>
      <el-table-column
        prop="Empleado.Nombre"
        label="Nombre y Apellido"
        min-width="200"
        :fixed="true"
        :sortable="true"
      ></el-table-column>
      <el-table-column
        prop="Empleado.Cedula"
        label="Cedula"
        min-width="130"
        :sortable="true"
      ></el-table-column>
      <el-table-column
        prop="Empleado.cuenta"
        label="Cuenta"
        min-width="130"
        :sortable="true"
      ></el-table-column>
      <el-table-column
        prop="Empleado.Deparmento.Name"
        label="Departamento"
        min-width="300"
        :sortable="true"
      ></el-table-column>
      <el-table-column
        prop="Empleado.Posicion.Name"
        label="Cargo"
        min-width="310"
        :sortable="true"
      ></el-table-column>
      <!-- </el-table-column> -->
      <el-table-column
        prop="Days"
        label="Dias"
        :sortable="true"
      ></el-table-column>

      <el-table-column label="INGRESOS" label-class-name="IngresosHeader">
        <el-table-column
          prop="SueldoTss"
          label="Salario Mensual"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="SalarioQuincenal"
          label="Salario Quincenal"
          min-width="160"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="diasTrabajados"
          label="Días Trabajados"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="MontoTrabajado"
          label="Monto Trabajado"
          min-width="170"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>

        <el-table-column
          prop="Comision"
          label="Comision"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="OtrosIngresos"
          label="Otros"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="Incetivos"
          label="Incentivos"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="Vacaciones"
          label="Prima Vacacional"
          min-width="160"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="SalarioRetroactivo"
          label="Salario Retroactivo"
          min-width="160"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        prop="total_income"
        label="Total Ingresos"
        min-width="150"
        :sortable="true"
        :formatter="(row, column, cellValue) => formatMonto(cellValue)"
      ></el-table-column>

      <el-table-column label="DESCUENTOS" label-class-name="DescuentosHeader">
        <el-table-column
          prop="Total_AFP"
          label="AFP"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="Total_SFS"
          label="SFS"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="PERCAPITA"
          label="PERCAPITA"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="PrivateInsurance"
          label="SEGURO PRIVADO"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="ISR_COBRADO"
          label="ISR"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="CXC"
          label="CXC"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="OtrosDescuentos"
          label="Otros"
          min-width="150"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
        <el-table-column
          prop="DESCUENTOS_ESPECIALES"
          label="Descuentos Especiales"
          min-width="180"
          :sortable="true"
          :formatter="(row, column, cellValue) => formatMonto(cellValue)"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        prop="total_discount"
        label="Total Descuentos"
        min-width="160"
        :sortable="true"
        :formatter="(row, column, cellValue) => formatMonto(cellValue)"
      ></el-table-column>
      <el-table-column
        prop="TOTAL_A_PAGAR"
        label="Neto a pagar"
        min-width="150"
        :sortable="true"
        :formatter="(row, column, cellValue) => formatMonto(cellValue)"
      ></el-table-column>
    </el-table>
    <slot>
      <div style="margin: 10px">
        <el-pagination
          style="margin-top: 20px"
          :layout="layout"
          :current-page="pagination.currentPage"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          v-bind="paginationBind"
        />
      </div>
    </slot>
    <!--
  </el-drawer>
  --></div>
</template>

<script>
import { formatMonto } from "@/utils";
import { getPaginatedItems } from "@/utils";

export default {
  name: "NominaHistoric",
  props: {
    NominahistoricIsVisible: {
      type: Boolean,
      default: false
    },
    NominaDetailData: {
      type: Object,
      default: () => {}
    },
    nominaStatusSelected: {
      type: Boolean,
      default: null
    },
    nominaPhaseSelected: {
      type: String,
      default: null
    },
    nominaYear: {
      type: Date,
      default: null
    },
    nominaMonth: {
      type: Date,
      default: null
    },
    biweeklySelected: {
      type: Number,
      default: null
    },
    conditionalActions: {
      type: Function,
      // eslint-disable-next-line no-unused-vars
      default: (payload) => true
    },
    DirectionSelected: {
      type: [Number],
      default: 0
    },
    EmployeeSelected: {
      type: [Number],
      default: 0
    },
    companySeleted: {
      type: String,
      default: "TB"
    },
    inactivateActions: {
      type: Boolean,
      default: false
    },
    NominaId: {
      type: Number,
      default: 0
    },
    NominaDataInfo: {
      type: Object,
      default: () => {}
    },
    NominaFrom: {
      type: String,
      default: ""
    },
    paymentForm: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      NominaData: [],
      fetchingNominaDetailData: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dataCache: [],
      data2: [],
      counter: 0,
      pageSizes: [10, 20, 30, 40, 100],
      page_Size: 0,
      layout: "total, sizes, prev, pager, next, jumper",
      paginateFromApi: false,
      paginationBind: {},
      approvalStatus: "",
      actions: [
        {
          command: "apply-income",
          label: "Aplicar Ingreso",
          Icon: ""
        },
        {
          command: "apply-discount",
          label: "Aplicar Descuento",
          Icon: ""
        }
      ]
    };
  },
  async mounted() {
    //if (this.NominaFrom !== "History") {
    await this.GetNominaItems();
    this.setPagination();
    //}
  },
  computed: {
    pageSize() {
      let ps = Number;
      if (this.page_Size > 0 && this.counter === 0) {
        ps = this.page_Size;
        this.handleSizeChange(this.page_Size);
      } else {
        ps = this.pagination.pageSize;
      }
      if (this.counter === 0) {
        this.sumCounter();
      }
      return ps;
    },
    historicIsVisible() {
      return this.NominahistoricIsVisible;
    },
    NominaDataFiltered() {
      let Nomina;
      Nomina = this.NominaData;
      if (
        this.DirectionSelected !== 0 &&
        this.EmployeeSelected !== 0 &&
        this.DirectionSelected !== "" &&
        this.EmployeeSelected !== ""
      ) {
        Nomina = this.NominaData.filter(
          (n) =>
            n.Empleado.Direccion.Id === this.DirectionSelected &&
            n.Empleado.ID === this.EmployeeSelected
        );
      } else if (
        (this.DirectionSelected === 0 || this.EmployeeSelected === "") &&
        this.EmployeeSelected !== 0 &&
        this.DirectionSelected !== ""
      ) {
        Nomina = this.NominaData.filter(
          (n) => n.Empleado.ID === this.EmployeeSelected
        );
      } else if (
        this.DirectionSelected !== 0 &&
        this.DirectionSelected !== "" &&
        (this.EmployeeSelected === 0 || this.EmployeeSelected === "")
      ) {
        Nomina = this.NominaData.filter(
          (n) => n.Empleado.Direccion.Id === this.DirectionSelected
        );
      } else if (
        (this.DirectionSelected === 0 && this.EmployeeSelected === 0) ||
        (this.DirectionSelected === "" && this.EmployeeSelected === "")
      ) {
        Nomina = this.NominaData;
      } else {
        Nomina = this.NominaData;
      }
      if (this.paymentForm !== 0) {
        Nomina = Nomina.filter(
          (n) => n.Empleado.FormPayment === this.paymentForm
        );
      }

      return Nomina;
    },
    selectActions() {
      let actions = this.actions;
      if (this.inactivateActions === true) {
        actions = [];
      }
      return actions;
    }
  },
  methods: {
    formatMonto,
    getPaginatedItems,
    sumCounter() {
      this.counter++;
    },
    handleCommand(command) {
      this.$emit("EmployeeNomina", command);
      // return this.$emit("rtable-push-action", command);
    },
    OnHistoricClose() {
      this.$emit("OnHistoricClose");
    },
    async GetNominaItems() {
      this.fetchingNominaDetailData = true;
      let fechaYear = new Date(this.nominaYear).getFullYear();
      let fechaMonth = new Date(this.nominaMonth).getMonth() + 1;
      let params;

      if (this.NominaDetailData) {
        params = {
          nominaId: this.NominaDetailData.Id,
          //Status: this.nominaStatusSelected ? this.nominaStatusSelected : false,
          //Etapa: this.nominaPhaseSelected,
          Year: this.nominaYear != "" ? fechaYear : null,
          Month: this.nominaMonth != "" ? fechaMonth : null,
          Biweekly: this.biweeklySelected,
          Company: this.companySeleted
        };
      } else if (this.NominaDataInfo) {
        const createdAt = new Date(this.NominaDataInfo.CreatedAt);

        params = {
          NominaId: this.NominaDataInfo.Id,
          //Status: this.NominaDataInfo.Open,
          //Etapa: this.NominaDataInfo.approvalstatus,
          Year: createdAt.getFullYear(),
          Month: createdAt.getMonth() + 1,
          Biweekly: this.NominaDataInfo.Biweekly,
          Company: this.NominaDataInfo.CompanySelected
        };
      } else {
        params = {
          NominaId: null,
          //Status: this.nominaStatusSelected,
          //Etapa: this.nominaPhaseSelected,
          Year: this.nominaYear.getFullYear(),
          Month: this.nominaMonth.getMonth() + 1,
          Biweekly: this.biweeklySelected,
          Company: this.companySeleted
        };
      }
      await this.$http
        .get("/api/Payroll/GetNomina", {
          //timeout: 99999999,
          params
        })
        .then((resp) => {
          let NominaNombre = "";
          if (resp.data.Items !== null) {
            this.NominaData = resp.data.Items;
            NominaNombre = resp.data.Nombre;
          } else {
            this.NominaData = [];
            NominaNombre = "Esta Nomina no ha sido Generada";
          }

          if (
            resp.data.Items &&
            resp.data.Items.length > 0 &&
            resp.data.Items[0].Nomina?.approvalstatus !== undefined
          ) {
            this.approvalStatus = resp.data.Items[0].Nomina.approvalstatus;
          }


          this.$emit("NominaTitulo", NominaNombre);
          this.$emit("NominaLoaded", this.NominaData);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.fetchingNominaDetailData = false;
        });
      this.fetchingNominaDetailData = false;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index <= 7) {
          sums[index] = "";
          return;
        }

        let values;
        if (index === 8) {
          values = data.map((item) => Number(item[column.property]));
        } else {
          values = data.map((item) => Number(item[column.property]));
        }
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              let sumary = prev + curr;
              return sumary;
            } else {
              let sumary = prev;
              return sumary;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });
      const result = [];
      sums.forEach((value, index) => {
        if (index <= 7) {
          sums[index] = "";
          return;
        }

        const formatter = new Intl.NumberFormat("es-DO", {
          stlye: "currency",
          currency: "DOP",
          minimumFractionDigits: 2
        });

        const f = formatter.format(value).replace(/,/g, "").replace(".", ".");
        result[index] = Number(parseFloat(f).toFixed(2)).toLocaleString("en");
        return;
      });

      return result;
    },
    getHeaderClass() {
      return "IngresosHeader";
    },
    handleCurrentChange(val) {
      if (this.paginateFromApi) {
        this.$emit("update-current-page", val);
      } else {
        this.$emit("update:loading", true);

        this.pagination.currentPage = val;
        const { data } = this.getPaginatedItems(
          this.dataCache,
          this.pagination.currentPage,
          this.pagination.pageSize
        );

        let self = this;
        setTimeout(() => {
          self.$emit("update:loading", false);
          // self.$emit("update:data", data);
          self.data2 = data;
        }, 100);
      }
    },
    handleSizeChange(val) {
      if (this.paginateFromApi) {
        this.$emit("update-page-size", val);
      } else {
        this.$emit("update:loading", true);
        this.pagination.pageSize = val;

        const { data } = this.getPaginatedItems(
          this.dataCache,
          this.pagination.currentPage,
          this.pagination.pageSize
        );

        let self = this;
        setTimeout(() => {
          self.$emit("update:loading", false);
          // self.$emit("update:data", data);
          self.data2 = data;
        }, 100);
      }
    },
    setPagination() {
      this.dataCache = this.NominaDataFiltered;
      this.pagination.total = this.NominaDataFiltered.length;
      this.handleCurrentChange(1);
    }
  },
  watch: {
    async NominahistoricIsVisible(val) {
      if (val) {
        await this.GetNominaItems();
      }
    },
    /*
    async nominaStatusSelected() {
      await this.GetNominaItems();
    },

    async nominaPhaseSelected() {
      await this.GetNominaItems();
    },
    */
    async nominaYear() {
      await this.GetNominaItems();
    },
    async nominaMonth() {
      await this.GetNominaItems();
    },
    async biweeklySelected() {
      await this.GetNominaItems();
    },
    NominaDataFiltered(val) {
      this.dataCache = val;
      this.pagination.total = val.length;
      this.handleCurrentChange(1);
    },
    async companySeleted() {
      await this.GetNominaItems();
    },
    async NominaDataInfo() {
      await this.GetNominaItems();
    },
    async paymentForm() {
      await this.GetNominaItems();
    },
    DirectionSelected() {},
    EmployeeSelected() {}
  }
};
</script>

<style scoped>
.IngresosHeader {
  color: green;
}
.DescuentosHeader {
  color: red;
}
</style>
